import accounting from 'accounting'

const plugin = {
  install(Vue) {
    Vue.filter('money', function (value, precision = 2) {
      if (typeof value === 'undefined') {
        return ''
      }
      return accounting.formatMoney(value / 100, { precision })
    })
  }
}

export default plugin
